import TechquisiteAccordion from "@/src/components/TechquisiteAccordion";
// new changes
import Layout from "@/src/layout/Layout";
import { client, urlFor } from "../../lib/client";
import Link from "next/link";
import { useState, Fragment } from "react";
import { Accordion } from "react-bootstrap";
import { NextSeo, ArticleJsonLd } from "next-seo";

import axios from "axios";
import { useRouter } from "next/router";

const ServiceDetails = ({
  servicePage,
  pricingSectionData,

}) => {
  const apiKey = `${process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY}`;
  const router = useRouter();

  const handleButtonClick = () => {
    router.push('/contact');
  };

  const [active, setActive] = useState("collapse0");

  const { pageBuilder, seo, slug, title } = servicePage;
  const {
    serviceFirstSection,
    serviceSecondSection,
    serviceThirdSection,
    serviceFourthSection,
    serviceFifthSection,
    serviceFirstAdditionalSection,
    serviceSecondAdditionalSection,
  } = pageBuilder;

  const { pricingPackages, pricingSectionHeading, pricingSectionMainHeading } =
    pricingSectionData;

  const createCheckoutSession = async (amount, package_name) => {
    const { loadStripe } = await import("@stripe/stripe-js");

    const stripePromise = loadStripe(apiKey);
    const stripe = await stripePromise;
    const checkoutSession = await axios.post("/api/create-checkout-session", {
      package_price: amount,
      package_name: package_name,
    });
    if (checkoutSession.statusCode === 500) return;
    const result = await stripe.redirectToCheckout({
      sessionId: checkoutSession.data.id,
    });
    toast.loading("Redirecting...");
    if (result.error) alert(result.error.message);
  };
  const {

    jsonLtd,
    metaDescription,
    metaTitle,

    type,
   
  } = seo;
  console.log(seo);

  return (
    <Fragment>
        <NextSeo
         title={metaTitle}
         description={metaDescription}
         metaDescription={metaDescription}
         canonical={`https://techquisite.com/solutions/${slug.current}`}
         robots="index, follow"
         additionalLinkTags={[
          {
            rel: 'icon',
            href: '/assets/images/favicon.png',
          },
          {
            rel: 'apple-touch-icon',
            href: 'https://www.test.ie/touch-icon-ipad.jpg',
            sizes: '76x76'
          },
         ]}
        
        openGraph={{
          type: type,
          url: `https://techquisite.com/solutions/${slug.current}`,
          title: metaTitle,
          description: metaDescription,
          metaDescription: metaDescription,
        }}
      />
      <ArticleJsonLd dataArray={JSON?.parse(jsonLtd)} />
      <Layout>
        {/* Page Banner Section Start */}
        <section
          className="page-banner pt-210 rpt-150 pb-25 rel z-1"
          style={{
            backgroundImage: "url(/assets/images/hero/hero-two-bg.png)",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="hero-title style-two mb-100 rmb-50 wow fadeInUp delay-0-2s globle-heading">
                  {title}
                </h1>
              </div>
            </div>
          </div>
        </section>
        {/* Page Banner Section End */}
        {/* Services Page About Area start */}
        <section className="service-page-about py-130 rpy-100 rel z-1">
          <div className="container">
            <div className="row gap-90 align-items-center">
              <div className="col-lg-6">
                <div className="service-about-image rmb-55">
                  <img
                    src={urlFor(serviceFirstSection.left_side_image)}
                    alt={serviceFirstSection.left_side_image.alt}
                  />
                  <div
                    className="service-about-box bgc-primary"
                    style={{
                      backgroundImage:
                        "url(/assets/images/shapes/work-step-bg.png)",
                      height: "300px",
                      width: "400px",
                      zIndex: "-1",
                    }}
                  >
                    {/* <Link legacyBehavior href="/service-details">
                    <a className="read-more">
                      <i className="fal fa-arrow-right" />
                    </a>
                  </Link> */}
                   
                  </div>
                </div>
              </div>
              <div className="col-xl-5 col-lg-6 mx-xl-auto">
                <div className="about-content wow fadeInUp delay-0-4s">
                  <div className="section-title mb-40">
                    <span className="sub-title mb-15">
                      {" "}
                      {serviceFirstSection.heading}{" "}
                    </span>
                    <h2>{serviceFirstSection.main_Heading}</h2>
                  </div>
                  <div className="content">
                    <p>{serviceFirstSection.paragraph}</p>
                    <ul className="list-style-three pt-15 pb-25">
                      {serviceFirstSection.services_items.map((item, index) => (
                        <li key={index}> {item.name} </li>
                      ))}
                    </ul>
                    <Link legacyBehavior href="/about">
                      <a className="read-more mt-10 color-primary">
                        Learn More <i className="far fa-arrow-right" />
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* additional section 01 */}
        <section className="service-page-about py-130 rpy-100 rel z-1">
          <div className="container">
            <div className="row gap-90 align-items-center">
              <div className="col-xl-5 col-lg-6 mx-xl-auto">
                <div className="about-content wow fadeInUp delay-0-4s">
                  <div className="section-title mb-40">
                    <span className="sub-title mb-15">
                      {" "}
                      {serviceFirstAdditionalSection.heading}{" "}
                    </span>
                    <h2>{serviceFirstAdditionalSection.main_Heading}</h2>
                  </div>
                  <div className="content">
                    <p>{serviceFirstAdditionalSection.paragraph}</p>
                    <ul className="list-style-three pt-15 pb-25">
                      {serviceFirstAdditionalSection.services_items.map(
                        (item, index) => (
                          <li key={index}> {item.name} </li>
                        )
                      )}
                    </ul>
                    {/* <Link legacyBehavior href="/about">
                    <a className="read-more mt-10 color-primary">
                      Learn More <i className="far fa-arrow-right" />
                    </a>
                  </Link> */}
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="service-about-image rmb-55 wow fadeInUp delay-0-2s">
                  <img
                    src={urlFor(serviceFirstAdditionalSection.left_side_image)}
                    alt={serviceFirstAdditionalSection.left_side_image.alt}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* section Additional end */}

        {/* Services Page About Area end */}
        {/* How We Works start */}
        <section className="how-we-works-area pb-100 rpb-70 rel z-1">
          <div className="container">
            <div className="section-title mb-40 wow fadeInUp delay-0-2s">
              <span className="sub-title mb-15">
                {" "}
                {serviceSecondSection.heading}{" "}
              </span>
              <h2> {serviceSecondSection.main_Heading} </h2>
              <div className="text mt-30">
                <p>{serviceSecondSection.paragraph}</p>
              </div>
            </div>
            <div className="row gap-90">
              {serviceSecondSection.services_items.map((item, index) => (
                <div key={index} className="col-xl-3 col-sm-6">
                  <div className={`work-step-item wow fadeInUp ${item.delay} `}>
                    <span className="step-number">Step {index + 1} </span>
                    <p style={{  fontWeight: '600', fontSize: '1.4rem', color: 'white'  }}  className="title"> {item.name} </p>
                    <div className="content">
                      <p> {item.paragraphs} </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* How We Works end */}
        {/* Video Area start */}
        <div className="video-area-two rel z-1">
          <div className="container-fluid">
            <div className="video-part style-two wow fadeInUp delay-0-2s">
              <img
                src={urlFor(serviceThirdSection.video_thumbnail)}
                alt={serviceThirdSection.video_thumbnail.alt}
              />
              <a
                href={serviceThirdSection.video_url}
              
                className="mfp-iframe video-play"
              >
                <i className="fas fa-play" />
              </a>
            </div>
          </div>
        </div>
        {/* Video Area end */}
        {/* Headline area start */}
        <div className="headline-area bgc-primary pt-80 pb-65">
          <div className="container-fluid">
            <div className="headline-wrap marquee">
              <span>
                {serviceThirdSection.services_items.map((item, index) => (
                  <span key={index} className="marquee-item">
                    <i className={item.icon} />
                    <b> {item.name} </b>
                  </span>
                ))}
              </span>
            </div>
          </div>
        </div>
        {/* Headline Area end */}
        {/* Why Choose Us start */}
        <section className="why-choose-area pt-100 rpt-70 rel z-1">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-8">
                <div className="why-choose-us-content">
                  <div className="section-title mb-60 wow fadeInUp delay-0-2s">
                    <span className="sub-title mb-15">
                      {" "}
                      {serviceFourthSection.heading}{" "}
                    </span>
                    <h2> {serviceFourthSection.main_Heading} </h2>
                  </div>
                  <div className="row gap-60">
                    {serviceFourthSection.services_items.map((item, index) => (
                      <div key={index} className="col-md-6">
                        <div
                          className={`why-choose-item wow fadeInUp delay-0-${
                            2 + index
                          }s`}
                        >
                          <div className="why-choose-header">
                            <i className="far fa-chevron-right" />
                            <h3> {item.name} </h3>
                          </div>
                          <p>{item.paragraph}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="why-choose-right style-two wow fadeInLeft delay-0-2s">
                  <img
                    src={urlFor(serviceFourthSection.right_side_image)}
                    alt={serviceFourthSection.right_side_image.alt}
                  />
                  <div className="why-choose-border-shape" />
                  <div className="text-shape">
                    <img
                      className="text"
                      src={urlFor(serviceFourthSection.hero_image_text_image)}
                      alt={serviceFourthSection.hero_image_text_image.alt}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Why Choose Us end */}

        {/* additional section 02 */}
        <section className="service-page-about py-130 rpy-100 rel z-1">
          <div className="container">
            <div className="row gap-90 align-items-center">
              <div className="col-lg-6">
                <div className="service-about-image rmb-55 wow fadeInUp delay-0-2s">
                  <img
                    src={urlFor(serviceSecondAdditionalSection.left_side_image)}
                    alt={serviceSecondAdditionalSection.left_side_image.alt}
                  />
                </div>
              </div>
              <div className="col-xl-5 col-lg-6 mx-xl-auto">
                <div className="about-content wow fadeInUp delay-0-4s">
                  <div className="section-title mb-40">
                    <span className="sub-title mb-15">
                      {" "}
                      {serviceSecondAdditionalSection.heading}{" "}
                    </span>
                    <h2>{serviceSecondAdditionalSection.main_Heading}</h2>
                  </div>
                  <div className="content">
                    <p>{serviceSecondAdditionalSection.paragraph}</p>
                    <ul className="list-style-three pt-15 pb-25">
                      {serviceSecondAdditionalSection.services_items.map(
                        (item, index) => (
                          <li key={index}> {item.name} </li>
                        )
                      )}
                    </ul>
                    {/* <Link legacyBehavior href="/about">
                    <a className="read-more mt-10 color-primary">
                      Learn More <i className="far fa-arrow-right" />
                    </a>
                  </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* additional section 02 end */}

        {/* Pricing style three start */}
        <section className="pricing-area-three pt-85">
          <div className="container container-1290">
            <div className="row justify-content-center">
              <div className="col-xl-8 col-lg-10">
                <div className="section-title text-center mb-60 wow fadeInUp delay-0-2s">
                  <span className="sub-title mb-20">
                    {" "}
                    {pricingSectionHeading}{" "}
                  </span>
                  <h2> {pricingSectionMainHeading} </h2>
                </div>
              </div>
            </div>

            <div className="row">
              {/* second object */}
              {pricingPackages.map((packages, index) => (
                <div
              
                  key={index}
                  className="col-xl-4 col-md-6 wow fadeInUp delay-0-4s"
                >
                  <div
       
                    className="pricing-plan-item style-three"
                    style={{
                      backgroundImage: `url(${packages.bg_image.url})`,
                      maxHeight: '60rem',
                      minHeight: '60rem'
                    }}
                  >
                    <div className="icon-title">
                      <div className="icon">
                        <img src={packages.icon_image.url} alt="Icon" />
                      </div>
                      <p  style={{  fontWeight: '600', fontSize: '1.4rem', color: 'white', }}  > {packages.name} </p>
                    </div>
                    <p style={{ 
                      maxHeight: '15rem',
                      minHeight: '15rem',
                     }} >{packages.paragraphs}</p>
                    <ul style={{ 
                        minHeight: '20rem',
                          maxHeight: '20rem',
                          overflowY: 'scroll',
                          paddingTop: '1rem'
                     }} className="list-style-one">
                      {packages.items.map((items, index) => (
                        <li key={index}> {items.name} </li>
                      ))}
                    </ul>

                    <div className="price-offer">
                  {/*}    <span className="price-text">
                        <span className="before">$</span>
                        <span className="price"> {packages.price} </span>
                      </span> 
                      <img
                        src="/assets/images/shapes/right-arrow.png"
                        alt="Arrow"
                      />
                      <span className="offer-text">
                        Save{" "}
                        {packages?.save_discount
                          ? packages?.save_discount
                          : "15%"}{" "}
                      </span>*/}
                    </div>
                    <button
                      legacyBehavior
                      href={"/contact"}
                      className="purchase-order w-100 mrgnt"
                     //</div> onClick={() =>
                        //createCheckoutSession(packages.price, packages.name)
                    //  }
                    onClick={handleButtonClick}
                    >
                      <span className="theme-btn w-100">
                        Contact Us <i className="far fa-arrow-right" />
                      </span>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* Pricing style three end */}

        {/* FAQ's Area start */}
        <section className="faq-area pt-130 rpt-95 pb-105 rpb-75 rel z-1">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-4">
                <div className="faq-iamge-part rmb-55 wow fadeInLeft delay-0-2s">
                  <img
                    src={urlFor(serviceFifthSection.left_side_image)}
                    alt={serviceFifthSection.left_side_image.alt}
                  />
                </div>
              </div>
              <div className="col-lg-8">
                <div className="faq-content-part wow fadeInRight delay-0-2s">
                  <div className="section-title mb-60">
                    <span className="sub-title mb-15">
                      {" "}
                      {serviceFifthSection.heading}{" "}
                    </span>
                    <h2> {serviceFifthSection.main_Heading} </h2>
                  </div>
                  <Accordion
                    defaultActiveKey="collapse0"
                    className="accordion"
                    id="faq-accordion-two"
                  >
                    {serviceFifthSection.services_items.map((data, i) => (
                      <TechquisiteAccordion
                        title={data.question}
                        key={i}
                        answer={data.answer}
                        event={`collapse${i}`}
                        onClick={() =>
                          setActive(
                            active == `collapse${i}` ? "" : `collapse${i}`
                          )
                        }
                        active={active}
                      />
                    ))}
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* FAQ's Area end */}
        {/* footer area start */}
      </Layout>
    </Fragment>
  );
};

export const getStaticPaths = async () => {
  // Fetch all possible slugs or paths for your pages
  const query = '*[_type == "servicePage"].slug.current';
  const slugs = await client.fetch(query);

  const paths = slugs.map(slug => ({
    params: { slug },
  }));

  return {
    paths,
    fallback: false, // or 'blocking' if you want server-side rendering for new paths post-build
  };
};

export const getStaticProps = async ({ params }) => {
  const { slug: pageSlug } = params;

  const query = `*[ _type == "servicePage" && slug.current == "${pageSlug}" ][0]`;
  const servicePage = await client.fetch(query);

  const { pageBuilder } = servicePage;
  const { servicesPricingPackage } = pageBuilder;

  // fetching layouts
  const queryForFooter = `*[ _type == "Footer"  ][0]`;
  const fetchFooter = await client.fetch(queryForFooter);

  const queryForHeader = `*[ _type == "Header"  ][0]`;
  const fetchHeader = await client.fetch(queryForHeader);

  // pricing section

  const transformData = (data) => {
    return data.map((item) => {
      const imageUrlConverted = urlFor(item.bg_image).url();
      const imageIconConverted = urlFor(item.icon_image).url();
      return {
        ...item,
        bg_image: {
          url: imageUrlConverted,
          alt: item.bg_image.alt ? item.bg_image.alt : 'bg image',
        },
        icon_image: {
          url: imageIconConverted,
          alt: item.icon_image.alt ? item.icon_image.alt : "icon",
        },
      };
    });
  };

  const pricingSectionHeading = servicesPricingPackage.heading;
  const pricingSectionMainHeading = servicesPricingPackage.main_Heading;
  const pricingPackages = transformData(servicesPricingPackage.prcing_packages);

  const pricingSectionData = {
    pricingSectionHeading,
    pricingSectionMainHeading,
    pricingPackages,
  };

  // fetching header data
  const headMenuData = `*[ _type == "Header"  ]{
  menu_items[]->{
           title,
           slug,
           menu_name,
           menu_name_number,
 }
}[0]`;
  const fHeaderMenuData = await client.fetch(headMenuData);
  const headerDataForMenu = fHeaderMenuData.menu_items;
  return {
    props: {
      servicePage,
      fetchFooter,
      fetchHeader,
      pricingSectionData,
      fHeaderMenuData: headerDataForMenu,
    },
  };
};
export default ServiceDetails;
